/* unplugin-vue-components disabled */import { render } from "./mg-menu-divider-item.vue?vue&type=template&id=800a86e0"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__